module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Arm-22471eabd8334c402d8aacedff344acb.png";